import React from "react";

export const HowSpecifyArtistCardWhenPublish: React.FC = () => {
  return <div id={"HowSpecifyArtistCardWhenPublish"}>
    <h2>
      Как указать карточку артиста при публикации альбома/трека
    </h2>
    <p>
      Укажите ссылку на карточку музыканта ВКонтакте в поле "VK" справа от названия артиста. Вы можете указать
      конкретную карточку для основных и приглашенных артистов как на уровне альбома, так и на уровне треков. Система
      принимает как цифровые адреса, например <span className={"text-blue-700"}>vk.com/artist/123456789087654</span>,
      так и адреса с коротким именем – <span className={"text-blue-700"}>vk.com/artist/artist_name</span>.
    </p>
    <div className={"text-center mb-3"}>
      <img className={"max-h-[350px]"} src={"/help/add_artist_to_album.jpg"} alt={"Добавить новый альбом"} />
    </div>
    <p>
      Также вы можете самостоятельно отследить, в какую карточку попал релиз, и при необходимости перенести его в
      корректную карточку. Для этого необходимо создать из альбома Черновик и заменить ссылку на артиста в
      соответствующем поле, Не забудьте сохранить и опубликовать изменения, чтобы они вступили в силу.
    </p>
    <p>
      Перенос релиза может быть недоступен, если в него уже были внесены изменения Командой ВКонтакте. В такой ситуации
      для переноса релиза можно отправить запрос по адресу <a
      href={"mailto:vkmusicsupport@corp.vk.com"}>vkmusicsupport@corp.vk.com</a> или по ссылке
      {" "}
      <a href={"https://vk.com/support?act=new_amt"} target={"_blank"} rel={"noreferrer"}>https://vk.com/support?act=new_amt</a>
    </p>
  </div>;
};
